import { RDSaudeTaglineBlack } from '../../assets/rd-saude-tagline/black'
import { RDSaudeTaglineColored } from '../../assets/rd-saude-tagline/colored'
import { RDSaudeTaglineDarkGreen } from '../../assets/rd-saude-tagline/dark-green'
import { RDSaudeTaglineLightGreen } from '../../assets/rd-saude-tagline/light-green'
import { RDSaudeTaglineWhite } from '../../assets/rd-saude-tagline/white'
import { RDSaudeTaglineYellow } from '../../assets/rd-saude-tagline/yellow'

export const logos = {
  white: {
    large: <RDSaudeTaglineWhite width={284} height={103} />,
    huge: <RDSaudeTaglineWhite width={365} height={129} />,
    enormous: <RDSaudeTaglineWhite width={444} height={157} />,
  },
  black: {
    large: <RDSaudeTaglineBlack width={284} height={103} />,
    huge: <RDSaudeTaglineBlack width={365} height={129} />,
    enormous: <RDSaudeTaglineBlack width={444} height={157} />,
  },
  colored: {
    large: <RDSaudeTaglineColored width={284} height={103} />,
    huge: <RDSaudeTaglineColored width={365} height={129} />,
    enormous: <RDSaudeTaglineColored width={444} height={157} />,
  },
  'light-green': {
    large: <RDSaudeTaglineLightGreen width={284} height={103} />,
    huge: <RDSaudeTaglineLightGreen width={365} height={129} />,
    enormous: <RDSaudeTaglineLightGreen width={444} height={157} />,
  },
  'dark-green': {
    large: <RDSaudeTaglineDarkGreen width={284} height={103} />,
    huge: <RDSaudeTaglineDarkGreen width={365} height={129} />,
    enormous: <RDSaudeTaglineDarkGreen width={444} height={157} />,
  },
  yellow: {
    large: <RDSaudeTaglineYellow width={284} height={103} />,
    huge: <RDSaudeTaglineYellow width={365} height={129} />,
    enormous: <RDSaudeTaglineYellow width={444} height={157} />,
  },
}
